export default {
    getRate: () => {
        return JSON.parse(localStorage.getItem("Rate"))
    },
    getIsAuthenticated: () => {
        const cookie = document.cookie;
        let isAuthenticated = cookie.includes("CommonApplicationAuthCookie_.masterweblight-auth");
        return isAuthenticated;
    },
    getSearched: (state) => {
        return state.searched
    },
    getAgreeToReceive(state){
        return state.iAgreeToReceive
    },
    getResultCount: (state) => {
        return state.resultCount
    },
    getTour: (state) => {
        return state.tour
    },
    getGDSParam: (state) => {
        return state.GDSParam
    },
    getSearchedSecondFilters: (state) => {
        return state.searchedSecondFilters
    },
    getSearchResult: (state) => {
        return state.searchResult
    },
    getSecondaryFiltersResult: (state) => {
        return state.secondaryFiltersResult
    },
    getPriceTableData: (state) => {
        return state.priceTableData
    },
    getPriceTableDataCities: (state) => {
        return state.priceTableDataCities
    },
    getMapItems: (state) => {
        return state.mapItems
    },
    getLuggage: () => (item) => {
        let res = false;
        item.flights.forEach(x => {
            let luggage = x.segments[0].baggageRestriction[0];
            let luggageCount = luggage.match(/\d/);

            if(luggageCount) {
                luggageCount = +luggageCount[0] > 0
            }

            if (luggage.match(/\d+ к|\d+ k/) || luggageCount) {
                res = true
            }
        });
        return res
    },
    timeToMinuts: () => (time) => {
        if (!time) return "";
        let hour = +time.split(":")[0];
        let minuts = +time.split(":")[1];

        return hour ? hour * 60 + minuts : minuts
    },
    fastSort: (state, getters) => (arr, sortProperty) => {
        if (arr.length < 2) {
            return arr
        }
        let pivot = arr[Math.floor(Math.random() * arr.length)][sortProperty];
        let equal = arr.filter(val => val[sortProperty] === pivot);
        let less = arr.filter(val => val[sortProperty] < pivot);
        let greater = arr.filter(val => val[sortProperty] > pivot);

        let res = [];
        getters['fastSort'](less, sortProperty).forEach(x => {
            res.push(x)
        })
        if (equal.length && sortProperty !== "price") {
            let property = sortProperty === "timeForward" ? "timeBackward" : "price"
            let newEqual = getters['fastSort'](equal, property);
            newEqual.forEach(x => {
                res.push(x)
            })
        } else if (sortProperty === "price") {
            equal.forEach(x => {
                res.push(x)
            })
        }
        getters['fastSort'](greater, sortProperty).forEach(x => {
            res.push(x)
        })
        return res
    },
    getReservationService: () => (payload) => {
        const res = {};

        // -> Интерфейс необходимый для брониования услуги (IReservationService)
        res.ServiceType = payload.serviceType;
        res.Code = payload.code;
        res.SubCode1 = payload.subcode1;
        res.SubCode2 = payload.subcode2;
        res.Packet = payload.packet;
        res.Partner = payload.partner;
        res.Day = payload.day;
        res.DurationInNight = payload.durationInNight;
        res.City = payload.cityId;
        res.Country = payload.countryId;
        res.Attributes = 0;
        res.AppliedCostOffersIds = payload.appliedCostOffersIds;

        // признак удаляемой услуги
        res.IsRemovable = payload.isRemovable;

        if (payload.isInvisible) {
            res.Attributes = res.Attributes | 64; // признак Invisible = 64 перечесление аттрибутов услуги ServiceAttribute
        }

        if (payload.isRemovable) {
            res.Attributes = res.Attributes | 1;
        }

        if (payload.isNotCalculated) {
            res.Attributes = res.Attributes | 32768; // признак NotCalculate = 32768 перечесление аттрибутов услуги ServiceAttribute
        }

        res.Type = payload.isNotCalculated ? res.Type | 2 : res.Type | 1; // нерассчитанная услуга, перечисление ReservationServiceType

        // <- Интерфейс необходимый для брониования услуги (IReservationService)

        // Пока оставим
        res.IsHooded = payload.isInvisible;
        res.IsNotCalculated = payload.isNotCalculated;

        res.BeginDateTimeString = payload.beginDateTime;
        res.EndDateTimeString = payload.endDateTime;

        // -> Дополнительная информация для отображения

        res.TemplateId = payload.templateId;
        res.Cost = payload.cost;
        res.ByPax = payload.byPax;

        // Информация по квоте услуги
        res.QuotaStatus = payload.quotaStatus;

        //Номер шаблона услуг по порядку
        res.Index = payload.index;

        //Является ли услуга маршрутной
        res.IsRoute = payload.isRoute;

        // Порядок при сортировке
        res.ServiceTemplateIndex = payload.index;

        // Идентификатор услуги в удаленной системе, если услуга создана на ее основе
        res.RemoteId = payload.remoteId;

        return res
    },
    getTouristModel: () => (payload)=> {
        return {
            IsMain: payload.IsMain,
            Number: payload.Number,
            AgeType: payload.AgeType,
            MaleFemaleSex: payload.MaleFemaleSex,
            FirstName: payload.FirstName,
            LastName: payload.LastName,
            Patronymic: payload.Patronymic,
            FirstNameRus: payload.FirstNameRus,
            LastNameRus: payload.LastNameRus,
            PatronymicRus: payload.PatronymicRus,
            InternationalPassportSeries: payload.InternationalPassportSeries,
            InternationalPassportNumber: payload.InternationalPassportNumber,
            InternationalPassportDateOfIssue: payload.InternationalPassportDateOfIssue,
            InternationalPassportDateOfIssueString: payload.InternationalPassportDateOfIssueString,
            InternationalPassportDateOfExpiry: payload.InternationalPassportDateOfExpiry,
            InternationalPassportDateOfExpiryString: payload.InternationalPassportDateOfExpiryString,
            internationalPassportByWhom: payload.internationalPassportByWhom,
            PassportSeries: payload.PassportSeries,
            PassportNumber: payload.PassportNumber,
            PassportDateOfIssue: payload.PassportDateOfIssue,
            PassportDateOfIssueString: payload.PassportDateOfIssueString,
            PassportByWhom: payload.PassportByWhom,
            Citizenship: payload.Citizenship,
            Phone: payload.Phone,
            Email: payload.Email,
            BirthDay: payload.BirthDay,
            BirthDayString: payload.BirthDayString,
            BirthPlace: payload.BirthPlace,
            CitizenID: payload.CitizenID,
            Age: payload.Age,
            HowDidYouHear: payload.HowDidYouHear,
            ResidenceRegion: payload.ResidenceRegion,
            EnableSmsNotifications: payload.EnableSmsNotifications
        }
    }
}
